import { render, staticRenderFns } from "./NewImagePropertyEditor.vue?vue&type=template&id=1a98e159&scoped=true&"
import script from "./NewImagePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./NewImagePropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./NewImagePropertyEditor.vue?vue&type=style&index=0&id=1a98e159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98e159",
  null
  
)

export default component.exports